import { render, staticRenderFns } from "./position.vue?vue&type=template&id=d6f1cf24&scoped=true"
import script from "./position.vue?vue&type=script&lang=js"
export * from "./position.vue?vue&type=script&lang=js"
import style0 from "./position.vue?vue&type=style&index=0&id=d6f1cf24&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f1cf24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6f1cf24')) {
      api.createRecord('d6f1cf24', component.options)
    } else {
      api.reload('d6f1cf24', component.options)
    }
    module.hot.accept("./position.vue?vue&type=template&id=d6f1cf24&scoped=true", function () {
      api.rerender('d6f1cf24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/basic/position.vue"
export default component.exports